import DiscountTypeMaster from './DiscountTypeMaster';

export default DiscountTypeMaster;
